/* eslint global-require: 0 */
export const images: { [key: string]: any } = {
  logo: require('./gtw.png'),
}
